module.exports = __webpack_public_path__ + "static/img/qr_pay.9656047.png";


//////////////////
// WEBPACK FOOTER
// ./static/qr_pay.png
// module id = ERu0
// module chunks = 1